import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ToggleQuestion } from '../../../classes/question-toggle';

@Component({
  selector: 'bepatient-input-toggle',
  templateUrl: './input-toggle.component.html',
  styleUrls: ['./input-toggle.component.scss'],
  standalone: false
})
export class InputToggleComponent {
  @Input() question: ToggleQuestion;
  @Input() parent: UntypedFormGroup;
}
